'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');







var _propertyDetails = require('../../redux/modules/propertyDetails');

















var _favoriteProperties = require('../../redux/modules/favoriteProperties');
var _propertyNotes = require('../../redux/modules/propertyNotes');
var _reviewedPins = require('../../redux/modules/reviewedPins');
var _propertySearch = require('../../redux/modules/propertySearch');

var _services = require('../../services');

var _messageModal = require('../../redux/modules/messageModal');
var _projectProperties = require('../../redux/modules/projectProperties');

var _constants = require('../../constants');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _routerAdapter = require('../../helpers/routerAdapter');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _fetchPropertyNoteById = require('../../utils/fetchPropertyNoteById');var _fetchPropertyNoteById2 = _interopRequireDefault(_fetchPropertyNoteById);

var _shareModal = require('../../redux/modules/shareModal');
var _manageProperties = require('../../redux/modules/manageProperties');
var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
// Styles
var PropertyDetailsModal = function (_Component) {_inherits(PropertyDetailsModal, _Component);function PropertyDetailsModal() {var _temp, _this, _ret;_classCallCheck(this, PropertyDetailsModal);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.























    setUpFavoritesAnalytics = function () {
      var propertyId = _this.props.propertyDetails.data.id;
      var isFavorite = _this.props.favoriteProperties.indexOf(propertyId) !== -1;

      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.favorites,
      isFavorite ? _analyticsConstants.eventAction.remove : _analyticsConstants.eventAction.add,
      _analyticsConstants.eventLabel.propertyDetailsModal);
    }, _this.

    checkIsProjects = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;return props.routeData.location === 'projects' ||
      (0, _get2.default)(props, 'propertyDetails.preloadData.entityType') === _constants.ENTITY_TYPES.PROJECT ||
      (0, _get2.default)(props, 'propertyDetails.data.entityType') === _constants.ENTITY_TYPES.PROJECT;}, _this.

    checkShouldIncludeDeleted = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;return (0, _get2.default)(props, 'routeData.optionType') === 'leads';}, _this.

    handleKeyDown = function (event) {
      if (event.keyCode === _constants.escKey) {
        event.stopPropagation();var _this$props =

        _this.props,isOpen = _this$props.isOpen,isProjectPropertyLightboxOpen = _this$props.isProjectPropertyLightboxOpen,isLightboxOpen = _this$props.propertyDetails.isLightboxOpen;
        var isDetailsModalShouldBeClosed = !isLightboxOpen && !isProjectPropertyLightboxOpen && isOpen;

        if (isDetailsModalShouldBeClosed) {
          _this.handlePopupClose();
        }

        if (isLightboxOpen) {
          _this.props.hideLightbox();
        }

        if (isProjectPropertyLightboxOpen) {
          _this.props.hideProjectPropertyLightbox();
        }
      }
    }, _this.

    handlePopupClose = function () {var _this$props$routeData =
      _this.props.routeData,location = _this$props$routeData.location,optionType = _this$props$routeData.optionType;
      if (_this.props.isPreview) {
        return _this.props.hidePreviewDetailsPopup();
      }

      if (!_this.props.isMobile && location === 'staff') {
        _this.props.onRequestClose();
        return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/' + location + '/' + optionType));
      }
      if (!_this.props.isMobile && location === 'manage_properties') {
        _this.props.onRequestClose();
        return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/manage_properties'));
      }
      if (!_this.props.isMobile && location === 'profile') {
        _this.props.onRequestClose();
        return _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/' + location + '/' + optionType));
      }

      if (
      (0, _constants.getSectionsNames)().includes(location) && !_this.props.isMobile ||
      location === 'company' || location === 'projects')
      {
        var routeData = (0, _omit2.default)(_this.props.routeData, ['searchResultParams', 'pid']);
        var pathname = (0, _routerAdapter.createUrl)(routeData);

        return _reactRouter.browserHistory.push({ pathname: pathname, state: routeData });
      }

      _this.props.onRequestClose();
      return undefined;
    }, _this.

    handleProjectEdit = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var id = (0, _get2.default)(_this.props, 'propertyDetails.propertyId');
      var address = (0, _get2.default)(_this.props, 'propertyDetails.data.address');
      var isForeign = (0, _checkIsForeignAddress2.default)(address);

      _reactRouter.browserHistory.push((0, _appendLocale2.default)(
      _this.props.locale, (
      isForeign ? '/foreign_project' : '/project') + '/edit?id=' + id));

    }, _this.

    handleEdit = function () {
      var id = (0, _get2.default)(_this.props, 'propertyDetails.propertyId');
      var address = (0, _get2.default)(_this.props, 'propertyDetails.data.address');
      var isForeign = (0, _checkIsForeignAddress2.default)(address);

      _this.props.editProperty(id);

      _reactRouter.browserHistory.push({
        pathname: (0, _appendLocale2.default)(_this.props.locale, (!isForeign ? '/property' : '/foreign_property') + '/edit'),
        query: { id: id } });

    }, _this.

    toggleFavorite = function (isProject) {
      // analytics
      _this.setUpFavoritesAnalytics();

      _this.props.toggleFavorite({
        property: _this.props.propertyDetails.data,
        token: _this.props.userToken,
        isProject: isProject });

    }, _this.

    addPropertyNote = function (note) {var _this$props2 =
      _this.props,token = _this$props2.userToken,id = _this$props2.propertyDetails.propertyId;
      // analytics
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.notes, _analyticsConstants.eventAction.add, _analyticsConstants.eventLabel.propertyDetailsModal);
      _this.props.addPropertyNote({ noteData: { id: id, note: note }, token: token });
    }, _this.

    fetchPropertyNote = function () {
      var id = _this.props.propertyDetails.propertyId;
      return (0, _fetchPropertyNoteById2.default)(id, _this.props.propertyNotes);
    }, _this.

    contactFormSubmitHandler = function (values) {var
      propertyId = _this.props.propertyDetails.propertyId;var _this$props3 =
      _this.props,locale = _this$props3.locale,userId = _this$props3.userId;
      var additionalProps = { locale: locale, project_id: propertyId };
      if (userId) {
        additionalProps.user_id = userId;
      }
      _this.props.sendProjectContactUsForm(Object.assign({},
      values,
      additionalProps));

    }, _this.

    renderPropertyDetails = function () {var _this$props4 =
















      _this.props,isMobile = _this$props4.windowDimentions.isMobile,locale = _this$props4.locale,_this$props4$property = _this$props4.propertyDetails,propertyId = _this$props4$property.propertyId,isLightboxOpen = _this$props4$property.isLightboxOpen,currentImage = _this$props4$property.currentImage,isModalContactsOpen = _this$props4$property.isModalContactsOpen,preloadData = _this$props4$property.preloadData,propertyData = _this$props4$property.data,isPreview = _this$props4.isPreview,translate = _this$props4.translate,isNative = _this$props4.isNative,isRtl = _this$props4.isRtl,userData = _this$props4.userData;
      var descriptionData = {
        translatedDescriptionRequired: _this.props.propertyDetails.translatedDescriptionRequired,
        descriptionLoaded: _this.props.propertyDetails.descriptionLoaded,
        translatedDescriptionText: _this.props.propertyDetails.translatedDescriptionText,
        showOriginalDescription: _this.props.propertyDetails.showOriginalDescription,
        descriptionLoading: _this.props.propertyDetails.descriptionLoading };

      var isFavorite = (_this.props.favoriteProperties || []).indexOf(propertyId) !== -1;
      var data = propertyData || null;

      return (
        _react2.default.createElement(_components.PropertyDetails, {
          key: 'propertyDetails',
          handlePopupClose: _this.handlePopupClose,
          routeData: _this.props.routeData,
          preloadData: preloadData,
          propertyData: Object.assign({},
          data, {
            id: propertyData ? propertyData.id : propertyId,
            property_type: propertyData && propertyData.property_type ?
            _this.props.translate('propertyTypes', propertyData.property_type)() :
            '' }),

          enPropertyType: propertyData && propertyData.property_type || '',
          translate: translate,
          locale: locale,
          currentImage: currentImage,
          isLightboxOpen: isLightboxOpen,
          incrementClicks: _services.AnalyticsEventService.createPropertyEvent,
          openLightbox: _this.props.openLightbox,
          hideLightbox: _this.props.hideLightbox,
          similarProperties: _this.props.similarProperties,
          changeLightboxActiveSlide: _this.props.changeLightboxActiveSlide,
          isMobile: isMobile,
          className: 'pageDetails',
          openModalContacts: _this.props.openModalContacts,
          hideModalContacts: _this.props.hideModalContacts,
          isModalContactsOpen: isModalContactsOpen,
          openModalShare: _this.props.openModalShare,
          hideModalShare: _this.props.hideModalShare,
          isModalShareOpen: _this.props.isModalShareOpen,
          isModal: true,
          isPreview: isPreview,
          isFavorite: isFavorite,
          userData: userData,
          handleEdit: _this.handleEdit,
          toggleFavorite: _this.toggleFavorite,
          addPropertyNote: _this.addPropertyNote,
          propertyNote: _this.fetchPropertyNote(),
          isNative: isNative,
          isRtl: isRtl,
          translateDescription: _this.props.translateDescription,
          resetDescriptionTranslate: _this.props.resetDescriptionTranslate,
          toggleDescriptionTranslation: _this.props.toggleDescriptionTranslation,
          descriptionData: descriptionData,
          detectDescriptionLanguage: _this.props.detectDescriptionLanguage }));


    }, _this.

    renderProjectDetails = function () {var _this$props5 =














      _this.props,routeData = _this$props5.routeData,userData = _this$props5.userData,_this$props5$property = _this$props5.propertyDetails,propertyId = _this$props5$property.propertyId,isLightboxOpen = _this$props5$property.isLightboxOpen,currentImage = _this$props5$property.currentImage,isModalContactsOpen = _this$props5$property.isModalContactsOpen,data = _this$props5$property.data,formSubmitting = _this$props5$property.formSubmitting,formSubmitted = _this$props5$property.formSubmitted,preloadData = _this$props5$property.preloadData,formError = _this$props5$property.formError;

      var descriptionData = {
        translatedDescriptionRequired: _this.props.propertyDetails.translatedDescriptionRequired,
        descriptionLoaded: _this.props.propertyDetails.descriptionLoaded,
        translatedDescriptionText: _this.props.propertyDetails.translatedDescriptionText,
        showOriginalDescription: _this.props.propertyDetails.showOriginalDescription,
        descriptionLoading: _this.props.propertyDetails.descriptionLoading };


      var summaryData = {
        translatedSummaryRequired: _this.props.propertyDetails.translatedSummaryRequired,
        translatedSummaryText: _this.props.propertyDetails.translatedSummaryText,
        showOriginalSummary: _this.props.propertyDetails.showOriginalSummary,
        summaryLoaded: _this.props.propertyDetails.summaryLoaded,
        summaryLoading: _this.props.propertyDetails.summaryLoading };


      var isFavorite = (_this.props.favoriteProperties || []).indexOf(propertyId) !== -1;

      return (
        _react2.default.createElement(_components.ProjectDetails, {
          key: 'projectDetails',
          projectData: data,
          userData: userData,
          handleEdit: _this.handleProjectEdit,
          isPreview: true,
          preloadData: preloadData,
          properties: _this.props.properties,
          projectProperties: _this.props.projectProperties,
          receiveSimilarProjectProperties: _this.props.receiveSimilarProjectProperties,
          routeData: routeData,
          addPropertyNote: _this.addPropertyNote,
          propertyNote: _this.fetchPropertyNote(),
          handlePopupClose: _this.handlePopupClose,
          descriptionData: descriptionData,
          isFavorite: isFavorite,
          toggleFavorite: _this.toggleFavorite,
          toggleDescriptionTranslation: _this.props.toggleDescriptionTranslation,
          detectDescriptionLanguage: _this.props.detectDescriptionLanguage,
          translateDescription: _this.props.translateDescription,
          resetDescriptionTranslate: _this.props.resetDescriptionTranslate,
          isModal: true,
          translate: _this.props.translate,
          locale: _this.props.locale,
          currentImage: currentImage,
          openLightbox: _this.props.openLightbox,
          hideLightbox: _this.props.hideLightbox,
          changeLightboxActiveSlide: _this.props.changeLightboxActiveSlide,
          isLightboxOpen: isLightboxOpen,
          isMobile: _this.props.isMobile,
          openModalContacts: _this.props.openModalContacts,
          hideModalContacts: _this.props.hideModalContacts,
          isModalContactsOpen: isModalContactsOpen,
          isRtl: _this.props.isRtl,
          sendProjectContactUsForm: _this.contactFormSubmitHandler,
          openMessageModal: _this.props.openMessageModal,
          formSubmitting: formSubmitting,
          formSubmitted: formSubmitted,
          formError: formError,
          userId: (0, _get2.default)(_this.props, 'userId'),
          userToken: (0, _get2.default)(_this.props, 'userToken'),
          summaryData: summaryData,
          toggleSummaryTranslation: _this.props.toggleSummaryTranslation,
          detectSummaryLanguage: _this.props.detectSummaryLanguage,
          translateSummary: _this.props.translateSummary }));


    }, _this.

    renderDetails = function () {return _this.checkIsProjects() ? _this.renderProjectDetails() : _this.renderPropertyDetails();}, _this.

    renderModalContent = function () {
      if (!_this.props.isOpen) {
        return null;
      }var _this$props6 =
















      _this.props,isMobile = _this$props6.windowDimentions.isMobile,locale = _this$props6.locale,_this$props6$property = _this$props6.propertyDetails,propertyId = _this$props6$property.propertyId,preloadData = _this$props6$property.preloadData,propertyData = _this$props6$property.data,isPreview = _this$props6.isPreview,translate = _this$props6.translate,isNative = _this$props6.isNative,routeData = _this$props6.routeData,isRtl = _this$props6.isRtl;

      var previewModalId = propertyData ? propertyData.id : '';
      var id = propertyId || previewModalId;
      var isForeign = propertyData ? propertyData.address.en.country_name !== 'Israel' : false;

      var modalContent = [
      _this.props.propertyDetails.loaded ?
      _this.renderDetails() :
      _react2.default.createElement(_components.PropertyDetailsPlaceholder, {
        key: 'propertyDetailsPlaceholder',
        translate: translate('propertyDetails'),
        data: preloadData,
        isMobile: isMobile,
        isRtl: isRtl })];




      if (isMobile && !isNative) {
        modalContent.push(
        _react2.default.createElement(_components.Footer, {
          isMobile: isMobile,
          key: 'footer',
          routeData: routeData,
          locale: locale,
          translate: translate,
          displaySocial: true,
          publishClicked: _this.props.publishClicked,
          isFooterShown: true }));


      }

      return modalContent.filter(function (x) {return !!x;});
    }, _temp), _possibleConstructorReturn(_this, _ret);}PropertyDetailsModal.prototype.componentDidMount = function componentDidMount() {window.document.body.addEventListener('keydown', this.handleKeyDown);};PropertyDetailsModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {if (!newProps.propertyDetails.isPreview && !newProps.propertyDetails.data && newProps.propertyDetails.propertyId && !newProps.propertyDetails.loading) {// Fetch data from scratch
      newProps.receiveProperty({ id: newProps.propertyDetails.propertyId, target: this.checkIsProjects(newProps) ? 'projects' : 'properties', includeDeleted: this.checkShouldIncludeDeleted(newProps) });newProps.getSimilarProperties({ property_id: newProps.propertyDetails.propertyId });this.props.setPinAsReviewed(newProps.propertyDetails.propertyId);}}; // shouldComponentUpdate(nextProps) {
  //   return nextProps.propertyDetails.loaded;
  // }
  PropertyDetailsModal.prototype.componentWillUnmount = function componentWillUnmount() {window.document.body.removeEventListener('keydown', this.handleKeyDown);};PropertyDetailsModal.prototype.render = function render() {var _props = this.props,isOpen = _props.isOpen,isNative = _props.isNative,isRtl = _props.isRtl;if (!isOpen) {
      return null;
    }
var _props2 =
    this.props,isMobile = _props2.isMobile,translate = _props2.translate,isPreview = _props2.isPreview;

    return (
      _react2.default.createElement(_components.Modal, {
          isOpen: isOpen,
          onRequestClose: this.handlePopupClose,
          className: 'propertyDetailsModal',
          isMobile: isMobile,
          translate: translate,
          fadeIn: !isPreview,
          isNative: isNative,
          isRtl: isRtl,
          isCloseButtonInvisible: true },

        this.renderModalContent()));


  };return PropertyDetailsModal;}(_react.Component);


PropertyDetailsModal.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  routeData: _propTypes2.default.object.isRequired,
  isMobile: _propTypes2.default.bool,
  windowDimentions: _propTypes2.default.object,
  translate: _propTypes2.default.func.isRequired,
  propertyDetails: _propTypes2.default.object,
  onRequestClose: _propTypes2.default.func,
  propertyNotes: _propTypes2.default.array,
  favoriteProperties: _propTypes2.default.array,
  toggleFavorite: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  setPinAsReviewed: _propTypes2.default.func,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  hideProjectPropertyLightbox: _propTypes2.default.func,
  openModalContacts: _propTypes2.default.func,
  hideModalContacts: _propTypes2.default.func,
  openModalShare: _propTypes2.default.func,
  hideModalShare: _propTypes2.default.func,
  hidePreviewDetailsPopup: _propTypes2.default.func,
  isOpen: _propTypes2.default.bool,
  isProjectPropertyLightboxOpen: _propTypes2.default.bool,
  isPreview: _propTypes2.default.bool,
  publishClicked: _propTypes2.default.func.isRequired,
  isNative: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  userToken: _propTypes2.default.string,
  translateDescription: _propTypes2.default.func,
  toggleDescriptionTranslation: _propTypes2.default.func,
  detectDescriptionLanguage: _propTypes2.default.func,
  resetDescriptionTranslate: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  sendProjectContactUsForm: _propTypes2.default.func,
  properties: _propTypes2.default.array,
  projectProperties: _propTypes2.default.array,
  userId: _propTypes2.default.string,
  isModalShareOpen: _propTypes2.default.bool,
  editProperty: _propTypes2.default.func,
  receiveSimilarProjectProperties: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  translateSummary: _propTypes2.default.func,
  detectSummaryLanguage: _propTypes2.default.func,
  similarProperties: _propTypes2.default.object,
  getSimilarProperties: _propTypes2.default.func,
  toggleSummaryTranslation: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(_ref) {var
  lang = _ref.lang,
  propertyDetails = _ref.propertyDetails,
  windowDimentions = _ref.windowDimentions,
  propertyNotes = _ref.propertyNotes,
  favoriteProperties = _ref.favoriteProperties,
  userAuthentication = _ref.userAuthentication,
  projectProperties = _ref.projectProperties,
  propertySearch = _ref.propertySearch,
  shareModal = _ref.shareModal;return (
    {
      locale: lang.locale,
      translate: (0, _reduxPagan.getLang)(lang, 'static'),
      propertyDetails: propertyDetails,
      propertyNotes: propertyNotes.data,
      favoriteProperties: favoriteProperties.favoriteIDs,
      windowDimentions: windowDimentions,
      properties: (0, _get2.default)(propertySearch, 'similarProjectPropertiesData') || [],
      isOpen: propertyDetails.isDetailsModalOpen,
      similarProperties: propertyDetails.similarProperties,
      isProjectPropertyLightboxOpen: projectProperties.isProjectPropertyLightboxOpen,
      isPreview: propertyDetails.isPreview,
      userAuthentication: userAuthentication,
      projectProperties: projectProperties.data || [],
      userId: userAuthentication.data ? userAuthentication.data.id : null,
      userToken: userAuthentication.data ? userAuthentication.data.access_token : null,
      isModalShareOpen: shareModal.isModalShareOpen });};


var mapDispatchToProps = {
  openLightbox: _propertyDetails.openLightbox,
  hideLightbox: _propertyDetails.hideLightbox,
  hideProjectPropertyLightbox: _projectProperties.hideProjectPropertyLightbox,
  changeLightboxActiveSlide: _propertyDetails.changeLightboxActiveSlide,
  receiveProperty: _propertyDetails.receiveProperty,
  receiveSimilarProjectProperties: _propertySearch.receiveSimilarProjectProperties,
  openModalContacts: _propertyDetails.openModalContacts,
  hideModalContacts: _propertyDetails.hideModalContacts,
  hidePreviewDetailsPopup: _propertyDetails.hidePreviewDetailsPopup,
  toggleFavorite: _favoriteProperties.toggleFavorite,
  openModalShare: _shareModal.openModalShare,
  hideModalShare: _shareModal.hideModalShare,
  addPropertyNote: _propertyNotes.addPropertyNote,
  setPinAsReviewed: _reviewedPins.setPinAsReviewed,
  translateDescription: _propertyDetails.translateDescription,
  toggleDescriptionTranslation: _propertyDetails.toggleDescriptionTranslation,
  detectDescriptionLanguage: _propertyDetails.detectDescriptionLanguage,
  resetDescriptionTranslate: _propertyDetails.resetDescriptionTranslate,
  sendProjectContactUsForm: _propertyDetails.sendProjectContactUsForm,
  openMessageModal: _messageModal.openMessageModal,
  editProperty: _manageProperties.editProperty,
  translateSummary: _propertyDetails.translateSummary,
  detectSummaryLanguage: _propertyDetails.detectSummaryLanguage,
  toggleSummaryTranslation: _propertyDetails.toggleSummaryTranslation,
  getSimilarProperties: _propertyDetails.getSimilarProperties };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
PropertyDetailsModal);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertyDetailsModal/PropertyDetailsModal.js
// module id = 2982
// module chunks = 0